export function summarizeAdherence(slots, logs) {
    const bySlot = new Map();
    let extraCount = 0;
    for (const log of logs) {
        if (log.scheduledAt == null) {
            extraCount += 1;
            continue;
        }
        const current = bySlot.get(log.scheduledAt);
        if (!current || log.recordedAt < current.recordedAt)
            bySlot.set(log.scheduledAt, log);
    }
    const counts = { given: 0, skipped: 0, refused: 0, partial: 0 };
    for (const slot of slots) {
        const log = bySlot.get(slot.epoch);
        if (log)
            counts[log.status] += 1;
    }
    const completed = counts.given + counts.skipped + counts.refused + counts.partial;
    return {
        expected: slots.length,
        ...counts,
        missing: Math.max(0, slots.length - completed),
        extraCount,
        givenRate: slots.length === 0 ? null : Math.round((counts.given / slots.length) * 1000) / 1000,
    };
}
